import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class BasketsService {
  createBasket = fields => {
    return fetch(config.config.endpointUrls.createBasket(), {
      method: 'POST',
      body: fields
    })
  }
  updateBasket = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateBasket(id), {
      method: 'PATCH',
      body: fields
    })
  }
  fetchBasketShippingMethods = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.fetchBasketShippingMethods(id), {
      method: 'GET'
    })
  }
  fetchBasketPaymentOptions = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.fetchBasketPaymentOptions(id), {
      method: 'GET'
    })
  }
}

export default new BasketsService()



// WEBPACK FOOTER //
// ../src/services/basketsService/basketsService.js